<template>
  <v-layout row >
    <v-dialog v-model="visibility" fullscreen hide-overlay persistent transition="custom-slide-x-transition">
      <div class="qrcode-wrapper">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="hideDialog">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>Responsável Documento</v-toolbar-title>
        </v-toolbar>
        <div class="qrcode-reader">
          <qrcode-stream v-if="visibility" :track="true" @decode="onDecode" @init="onInit" />
        </div>
        <v-form @submit.prevent="fetchDocument" novalidate class="qrcode-form-wrapper">
            <div class="container qrcode-form">
              <v-text-field
                v-model="document"
                label="Documento"
                ml-1
                required
                data-test="document-text-field"
              ></v-text-field>
              <v-btn type="submit" large color="primary" data-test="ok-button">OK</v-btn>
            </div>
        </v-form>
      </div>
    </v-dialog>
  </v-layout>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import { mapActions } from 'vuex'

export default {

  name: 'qr-code-view',

  components: { QrcodeStream },

  props: {
    visibility: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    qrcodeError: null,
    document: ''
  }),

  watch: {
    visibility (newValue) {
      if (newValue) {
        this.document = ''
      }
    }
  },

  methods: {
    ...mapActions({
      fetchResponsibleInfos: 'responsibleInfos/fetchResponsibleInfos',
      showSnack: 'snackbar/showSnack'
    }),

    fetchDocument (e) {
      if (this.document) {
        this.fetchResponsibleInfos(this.document)
        this.hideDialog()
      }
    },

    hideDialog () {
      this.$emit('hideDialog')
    },

    onDecode (result) {
      if (result) {
        this.qrcode = result
        this.$store.dispatch('responsibleInfos/fetchResponsibleInfos', this.qrcode)
        this.hideDialog()
      } else {
        this.qrcodeError = 'Código inválido.'
      }
    },

    async onInit (promise) {
      try {
        await promise
      } catch (qrcodeError) {
        this.studentField = true
        switch (qrcodeError.name) {
          case 'NotAllowedError':
            this.qrcodeError = 'Erro: Você precisa dar acesso à câmera.'
            break
          case 'NotFoundError':
            this.qrcodeError = 'Erro: Nenhuma câmera encontrada.'
            break
          case 'NotSupportedError':
            this.qrcodeError = 'Erro: Plataforma não suportada.'
            break
          case 'NotReadableError':
            this.qrcodeError = 'Erro: Câmera está sendo utilizada em outra aplicação.'
            break
          case 'OverconstrainedError':
            this.qrcodeError = 'Erro: A câmera instalada não é suportada.'
            break
          case 'StreamApiNotSupportedError':
            this.qrcodeError = 'Erro: Stream API não encontrada na plataforma.'
            break
          default:
            this.qrcodeError = 'Erro desconhecido. Entre em contato com o suporte.'
        }

        this.showSnack(this.qrcodeError)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .qrcode
    &-wrapper
      display flex
      flex-direction column
      width 100%
      height 100%
    &-reader
      flex 1
      overflow hidden
      background #000
    &-form-wrapper
      overflow hidden
      display flex
      height 56px
      margin-left 5px
      background-color #fff
    &-form
      display flex
      padding 0
      width 100%
      &-input
        flex 1

</style>
